import { Grid } from "@mui/material";
import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { updateInvitation } from "../../../apis/invitations.api";
import { SaveAndCancelButton } from "../../../components/buttons";
import { AppModalDialogBox } from "../../../components/modals";
import { LabelAndValue } from "../../../components/typography";
import { convertToFullName } from "../../../services/utils";
import { EmailAddressBox } from "../../components/email-addressbox";

const EMPTY_MEMBERS: Array<{ email?: string }> = [];

interface AddMemberModalProps {
  event: any;
  onClose: () => void;
  initialMembers?: Array<{ email?: string }>;
  onSuccess?: () => void;
  modalTitle?: string;
}

function AddMemberModal({
  event,
  onClose,
  initialMembers = EMPTY_MEMBERS,
  onSuccess,
  modalTitle = "Add Members",
}: AddMemberModalProps) {
  const { ambassador, client, datetime, iId, invitationId } = event;
  const invitationRecordId = iId || invitationId;

  const initialEmails = useMemo(
    () =>
      initialMembers?.map((member) => member?.email).filter(Boolean) || [],
    [initialMembers]
  );

  const [emailIds, setEmailds]: any = useState({
    list: [],
    invalidEmailIds: [],
  });
  const dispatch = useDispatch();

  const handleOnEmailAddressesChange = (payload) => {
    setEmailds(payload);
  };

  const onSubmit = async () => {
    if (emailIds.invalidEmailIds.length || !invitationRecordId) return;

    const payload = {
      additionalMembers: emailIds.list.map((email) => ({ email })),
      id: invitationRecordId,
    };

    const response: any = await dispatch(updateInvitation(payload));

    if (response.success) {
      onSuccess?.();
      onClose();
    }
  };

  return (
    <AppModalDialogBox
      isModalOpen={true}
      handleClose={onClose}
      title={modalTitle}
      size={"sm"}
      actionButtonRenderer={
        <SaveAndCancelButton
          primaryText={"Submit"}
          isPrimaryButtonDisabled={Boolean(emailIds.invalidEmailIds.length)}
          defaultText={"Cancel"}
          onPrimaryActionClick={onSubmit}
          onDefaultButtonClick={onClose}
        />
      }
    >
      <Grid container flexDirection={"column"}>
        <LabelAndValue
          sx={{ mb: 1 }}
          labelxs={3}
          labelmd={3}
          labelsm={3}
          size={13}
          valuexs={7}
          label="Time"
          value={`${datetime}`}
        />
        <LabelAndValue
          sx={{ mb: 1 }}
          labelxs={3}
          labelmd={3}
          labelsm={3}
          size={13}
          valuexs={7}
          label="Ambassador"
          value={convertToFullName(ambassador?.firstName, ambassador?.lastName)}
        />
        <LabelAndValue
          sx={{ mb: 1 }}
          labelxs={3}
          labelmd={3}
          labelsm={3}
          valuexs={7}
          label="Client"
          size={13}
          value={convertToFullName(client?.firstName, client?.lastName)}
        />
      </Grid>
      <EmailAddressBox
        onValueChange={handleOnEmailAddressesChange}
        defaultValue={initialEmails.length ? initialEmails : undefined}
        label="Attendees"
      />
    </AppModalDialogBox>
  );
}

export { AddMemberModal };
